/**
 * Session token holder — Surface Layer (/01)
 *
 * A tiny synchronous holder for the current access token (JWT) so the
 * BFF read/write clients and the ActionFrame transport can attach
 * `Authorization: Bearer <token>` without coupling to React or to the
 * auth vendor. The real session hook (useSurfaceSession) keeps this
 * updated on every auth-state change; the persistence + dispatch layers
 * read it. Vendor-neutral: this module imports no auth SDK.
 */

let currentAccessToken: string | null = null;

export function setAccessToken(token: string | null): void {
  currentAccessToken = token;
}

export function getAccessToken(): string | null {
  return currentAccessToken;
}

export function hasAccessToken(): boolean {
  return currentAccessToken !== null && currentAccessToken.length > 0;
}
